import React, { useState, useEffect } from "react";
import SubHeader from "./subHeader";
import EventsItem from "./eventsItem";
import NewsItem from "./newsItem";

function MostPopular(props) {
  const { lang, showSubheader, category, locale, type } = props;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        city_id: process.env.REACT_APP_CITY_ID,
        type: type,
        category: category,
      }),
    };
    fetch(process.env.REACT_APP_API + "get_most_popular.php", requestOptions)
      .then((response) => response.json())
      .then((event) => {
        setData(event);
        setLoading(false);
      });
  }, [category]);

  return (
    <div className="col-xl-12">
      {showSubheader && (
        <SubHeader
          title={"Najviše pregleda".translate()}
          loading={loading}
          h2
          icon={<i className="bi bi-star-fill icon-primary"></i>}
        />
      )}
      <div className="row g-0 px-2 pt-1 pb-3 mb-3">
        {loading && type === "event" && <EventsItem loading={loading} />}
        {!loading && data && type === "event" && (
          <EventsItem
            categories={data.categories}
            lang={lang}
            data={data.event}
            locale={locale}
            h3
            loading={loading}
          />
        )}
        {!loading && type === "event" && !data.event && (
          <div className="p-2 text-center">{"Nema rezultata".translate()}</div>
        )}
        {loading && type === "news" && <NewsItem loading={loading} />}
        {!loading && data && type === "news" && (
          <NewsItem
            loading={loading}
            newsItem={data}
            locale={locale}
            lang={lang}
            h3
          />
        )}
        {!loading && type === "news" && !data && (
          <div className="p-2 text-center">{"Nema rezultata".translate()}</div>
        )}
      </div>
    </div>
  );
}

export default MostPopular;
